import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const currentLocation = localStorage.getItem("userLocation")
  ? JSON.parse(localStorage.getItem("userLocation"))
  : {};
const username = localStorage.getItem("username");
const locationParams = {
  longitude: currentLocation?.longitude,
  latitude: currentLocation?.latitude,
  city: currentLocation?.city,
  state: currentLocation?.state,
  username: username,
  country: currentLocation?.country,
  area: currentLocation?.area,
};
export const vendorService = createApi({
  reducerPath: "vendorService",
  tagTypes: ["vendor", "service", "appoinment"],
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.upswap.app/api",
    prepareHeaders: (headers) => {
      // Get the token from localStorage for each request
      const token = localStorage.getItem("access");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    deleteService: builder.mutation({
      invalidatesTags: ["service"],
      query: (id) => ({
        url: `/appointments/delete-service/${id}/`,
        method: "DELETE",
      }),
    }),
    getAllServices: builder.query({
      providesTags: ["service", "appoinment"],
      query: () => ({
        url: "/appointments/get-services/",
        method: "GET",
      }),
    }),
    addVendorService: builder.mutation({
      invalidatesTags: ["service"],
      query: (newPost) => ({
        url: "appointments/create-service/",
        method: "POST",
        body: newPost,
      }),
    }),

    updateService: builder.mutation({
      invalidatesTags: ["service"],
      query: ({ id, body }) => ({
        url: `appointments/update-service/${id}/`,
        method: "PUT",
        body: body,
      }),
    }),
    getSingleService: builder.query({
      providesTags: ["service"],
      query: (id) => ({
        url: `/appointments/get-service/${id}/`,
        method: "GET",
      }),
    }),
    getAllProviders: builder.query({
      providesTags: ["vendor"],
      query: () => ({
        url: "/appointments/get-providers/",
        method: "GET",
      }),
    }),

    uploadImage: builder.mutation({
      invalidatesTags: ["vendor"],
      query: (newPost) => ({
        url: "/UploadImagesAPI/",
        method: "POST",
        body: newPost,
      }),
    }),
    getVendorLocation: builder.query({
      providesTags: ["vendor"],
      query: (id) => ({
        url: `vendor/addresses/?vendor_uuid=${id}/`,
        method: "GET",
      }),
    }),
    addVendorDeal: builder.mutation({
      invalidatesTags: ["vendor"],
      query: (newPost) => ({
        url: "/deals/create/",
        method: "POST",
        body: newPost,
      }),
    }),

    getVendorKYCStatus: builder.query({
      providesTags: ["vendor"],
      query: (vendorId) => ({
        url: `vendor/status/${vendorId}/`,
        method: "GET",
      }),
    }),

    getAllBrowseService: builder.query({
      providesTags: ["service"],
      query: () => ({
        url: `/appointments/get-all-services/`,
        method: "GET",
      }),
    }),
    serviceFavorite: builder.mutation({
      invalidatesTags: ["service"],
      query: (serviceId) => ({
        url: `service/${serviceId}/favorite/`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    buyDealDummy: builder.mutation({
      invalidatesTags: ["service"],
      query: (body) => ({
        url: "buy-deal/dummy/",
        method: "POST",
        body: body,
      }),
    }),
    getAllPopularDeals: builder.query({
      providesTags: ["service"],
      query: () => ({
        url: `/deals/lists/?lat=${locationParams?.latitude}&lng=${locationParams?.longitude}`,
        method: "GET",
      }),
    }),
    getDealDetails: builder.query({
      providesTags: ["service"],
      query: (id) => ({
        url: `/deals/details/${id}`,
        method: "GET",
        params: {
          location: JSON.stringify(locationParams),
        },
      }),
    }),
    getAllActivities: builder.query({
      providesTags: ["customer"],
      query: () => ({
        url: `/activities/lists/?lat=${locationParams?.latitude}&lng=${locationParams?.longitude}`,
        method: "GET",
      }),
    }),
    getActivityDetails: builder.query({
      providesTags: ["customer"],
      query: (id) => ({
        url: `/activities/details/${id}/`,
        method: "GET",
      }),
    }),

    getUserDealPurchases: builder.query({
      providesTags: ["service"],
      query: () => ({
        url: `/get/user/purchases/`,
        method: "GET",
      }),
    }),

    getVendorDealSales: builder.query({
      providesTags: ["service"],
      query: (vednorId) => ({
        url: `/get/vendor/sales/${vednorId}`,
        method: "GET",
      }),
    }),
    addQrCode: builder.mutation({
      invalidatesTags: ["service"],
      query: ({ id, body }) => ({
        url: `/fulfill-deal/dummy/${id}/`,
        method: "PATCH",
        body: body,
      }),
    }),

    getMyDeals: builder.query({
      query: (id) => ({
        url: `/my-deals/${id}/`,
        method: "GET",
      }),
    }),
    addProvider: builder.mutation({
      invalidatesTags: ["vendor"],
      query: (body) => ({
        url: "appointments/create-provider/",
        method: "POST",
        body: body,
      }),
    }),

    getSingleProviders: builder.query({
      providesTags: ["vendor"],
      query: (id) => ({
        url: `/appointments/get-provider/${id}/`,
        method: "GET",
      }),
    }),
    deleteProvider: builder.mutation({
      invalidatesTags: ["vendor"],
      query: (id) => ({
        url: `/appointments/delete-provider/${id}/`,
        method: "DELETE",
      }),
    }),
    updateprovider: builder.mutation({
      invalidatesTags: ["vendor"],
      query: ({ id, body }) => ({
        url: `appointments/update-provider/${id}/`,
        method: "PUT",
        body: body,
      }),
    }),
    addVendorRating: builder.mutation({
      invalidatesTags: ["vendor"],
      query: (body) => ({
        url: `/rate/vendor/`,
        method: "POST",
        body: body,
      }),
    }),
    getAllAppointments: builder.query({
      query: (vendorId) => `/appointments/get-appointments/${vendorId}/`,
      providesTags: ["appoinment"],
    }),
    changeAppoinmentStatus: builder.mutation({
      invalidatesTags: ["appoinment"],
      query: ({ id, body }) => ({
        url: `/appointments/update-status/appointment/${id}/`,
        method: "PATCH",
        body: body,
      }),
    }),
    bookAppointment: builder.mutation({
      invalidatesTags: ["appoinment"],
      query: (newPost) => ({
        url: "/appointments/book-appointment/",
        method: "POST",
        body: newPost,
      }),
    }),
    getAppointmentBookingDetails: builder.query({
      query: (appointmentId) =>
        `appointments/details/appointment/${appointmentId}/`,
      providesTags: ["appoinment"],
    }),
    getAppointmentUserBookings: builder.query({
      query: () => `/appointments/get-user/appointments/`,
      providesTags: ["appoinment"],
    }),
    addProviderTimeSlots: builder.mutation({
      invalidatesTags: ["vendor"],
      query: ({ provider_id, body }) => ({
        url: `/appointments/providers/${provider_id}/generate-slots/`,
        method: "POST",
        body: body,
      }),
    }),
    getVendors: builder.query({
      query: () => `vendor/lists/`,
    }),
    addDealRating: builder.mutation({
      invalidatesTags: ["service"],
      query: (newPost) => ({
        url: "/rate-deal/",
        method: "POST",
        body: newPost,
      }),
    }),
    getDealRating: builder.query({
      providesTags: ["service"],
      query: (deal_id) => ({
        url: `/rate-deal/${deal_id}/`,
        method: "GET",
      }),
    }),
    updateDealRating: builder.mutation({
      invalidatesTags: ["service"],
      query: ({ deal_id, body }) => ({
        url: `/rate-deal/${deal_id}/`,
        method: "PUT",
        body: body,
      }),
    }),
  }),
});

export const {
  useAddVendorServiceMutation,
  useDeleteServiceMutation,
  useGetAllServicesQuery,
  useGetAllProvidersQuery,
  useGetSingleServiceQuery,
  useUpdateServiceMutation,
  useUploadImageMutation,
  useGetVendorLocationQuery,
  useAddVendorDealMutation,
  useGetVendorKYCStatusQuery,
  useGetAllBrowseServiceQuery,
  useServiceFavoriteMutation,
  useBuyDealDummyMutation,
  useGetDealDetailsQuery,
  useGetAllPopularDealsQuery,
  useGetAllActivitiesQuery,
  useGetActivityDetailsQuery,
  useGetUserDealPurchasesQuery,
  useGetVendorDealSalesQuery,
  useAddQrCodeMutation,
  useAddProviderMutation,
  useDeleteProviderMutation,
  useGetSingleProvidersQuery,
  useUpdateproviderMutation,
  useAddVendorRatingMutation,
  useGetMyDealsQuery,
  useGetAllAppointmentsQuery,
  useBookAppointmentMutation,
  useChangeAppoinmentStatusMutation,
  useGetAppointmentBookingDetailsQuery,
  useGetAppointmentUserBookingsQuery,
  useAddProviderTimeSlotsMutation,
  useGetVendorsQuery,
  useAddDealRatingMutation,
  useGetDealRatingQuery,
  useUpdateDealRatingMutation,
} = vendorService;
export default vendorService;
